import { Box, Grid, SxProps, useMediaQuery, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles/createTheme';
import LoadingSpinner from 'components/loading-spinner';
import Paper from 'components/paper';
import React from 'react';
import DeliveryCard from 'views/delivery-board/components/delivery-card';
import { DeliveryBoardItem } from 'views/delivery-board/types/delivery-board-model.type';

type Props = {
  width?: string;
  minWidth?: string;
  borderTop?: string;
  data?: DeliveryBoardItem[];
  sx?: SxProps<Theme> | undefined;
  isLoading?: boolean;
};

const ColumnsContainer: React.FC<Props> = ({ width, minWidth = 'auto', borderTop, sx, data, isLoading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid gap={0} maxHeight={'60vh'} overflow={'auto'}>
      {isLoading ? (
        <LoadingSpinner />
      ) : !isMobile ? (
        <Box height={'100%'} width={width} minWidth={minWidth}>
          <Box mt={5}>
            {data?.map((card, key) => (
              <Box key={key}>
                <DeliveryCard data={card} />
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Paper transparent sx={{ minWidth: '380px', maxHeight: '60vh', overflow: 'scroll' }}>
          {data?.map((card, key) => (
            <Box key={key}>
              <DeliveryCard data={card} />
            </Box>
          ))}
        </Paper>
      )}
    </Grid>
  );
};

export default ColumnsContainer;
